export const error = (error: any) => `${error}`.replace('Error: ', '');
